// AUTO-GENERATED by scripts/extract-yadadri-geo.cjs — do not edit by hand.
// Source: data/Mandal_Telangana.geojson filtered to Yadadri Bhuvanagiri.

export const GIS_DISTRICT_NAME = 'Yadadri Bhuvanagiri'

/** Mandal name (raw dataset key, e.g. "Turkapalle_M") → [lon, lat] centroid. */
export const MANDAL_CENTROIDS: Record<string, readonly [number, number]> = {
  'Addagudur': [79.3506, 17.4136],
  'Alair': [79.0739, 17.6503],
  'Athmakur (M)': [79.1631, 17.4683],
  'B.Pochampally': [78.8151, 17.3575],
  'Bhongiri': [78.9142, 17.4905],
  'Bibinagar': [78.8092, 17.4543],
  'Bommalaramaram': [78.7578, 17.578],
  'Choutuppal': [78.8817, 17.2712],
  'Gundala': [79.2527, 17.5346],
  'Motakondur': [79.097, 17.5373],
  'Mothkur': [79.269, 17.4256],
  'Narayanapoor': [78.8807, 17.1446],
  'Rajapeta': [78.9364, 17.7371],
  'Ramannapet': [79.1244, 17.3003],
  'Turkapalle_M': [78.8223, 17.6618],
  'Valigonda': [79.04, 17.3889],
  'Yadagirigutta': [78.9589, 17.6088],
}
